import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import "../../../styles/live-subscriptions/live-subscriptions.css";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import {
  fetchLiveSubsLogsData,
  fetchLiveSubsStatsData,
} from "../../../redux/live-reducers/liveSlice";
import SubscriptionWebhook from "./SubscriptionWebhook";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import LiveSubsStats from "./live-subs-stats/LiveSubsStats";
import LiveSubsLogs from "./live-subs-logs/LiveSubsLogs";
import CmnFilters from "../../lead-management/common/CmnFilters";

const LiveSubscriptionStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedPlanType: "",
    leadAddDateFrom: FORMATTED_TODAY_DATE_YYYYMMDD,
    leadAddDateTo: FORMATTED_TODAY_DATE_YYYYMMDD,
    searchString: "",
    showFiltersDropdown: false,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    type: allFilters.selectedPlanType?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [statsData, setStatsData] = useState({
    total: 0,
    regular_subscriptions: 0,
    personal_training: 0,
  });
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getLiveSubscriptionStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchLiveSubsStatsData({
        filters: { ...rest },
        token: userInfoData?.token,
      })
    );
  }

  function getLiveSubscriptionLogs(filters) {
    dispatch(
      fetchLiveSubsLogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getLiveSubscriptionStats(filters);
  }, [
    filters.gym_id,
    allFilters.selectedPlanType,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    getLiveSubscriptionLogs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      type: allFilters.selectedPlanType?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedPlanType,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  return (
    <>
      <Row>
        <Col>
          <SubscriptionWebhook
            userInfoData={userInfoData}
            filters={filters}
            setStatsData={setStatsData}
            setAllDatas={setAllDatas}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Live New Subscriptions"
            subheading="Real-time Subscription Monitoring and Management"
            onReload={() => {
              getLiveSubscriptionStats(filters);
              getLiveSubscriptionLogs(filters);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="live-subscriptions"
            userInfoData={userInfoData}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickReset={onResetFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
          />
        </Col>
      </Row>

      {allFilters.showFiltersDropdown && (
        <Row>
          <Col>
            <LiveSubsStats statsData={statsData} setStatsData={setStatsData} />
          </Col>
        </Row>
      )}

      {/* <Row>
        <Col>
          <LiveFeed subscriptions={filteredSubscriptions.slice(0, 5)} />
        </Col>
      </Row> */}

      <Row>
        <Col>
          <LiveSubsLogs
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            allDatas={allDatas}
            setAllDatas={setAllDatas}
            userInfoData={userInfoData}
            callFunction={() => {
              getLiveSubscriptionStats(filters);
              getLiveSubscriptionLogs(filters);
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default LiveSubscriptionStructure;
